import type { Equipamento } from "./rede";

/** A fração em metros usa exclusivamente a referência da ficha, nunca as dimensões do desenho. */
export function nivelReservatorio(e: Equipamento, metros: number | null, percentual: number | null) {
  const lamina = e.reservatorio?.altura_lamina_m, operacional = e.reservatorio?.nivel_max_m;
  const maximo = typeof lamina === "number" && lamina > 0 ? lamina
    : typeof operacional === "number" && operacional > 0 ? operacional : null;
  const m = metros !== null && Number.isFinite(metros) && metros >= 0 ? metros : null;
  const pct = percentual !== null && Number.isFinite(percentual) && percentual >= 0 ? percentual : null;
  const fracao = m !== null && maximo !== null ? m / maximo : pct !== null ? pct / 100 : null;
  return { fracao: fracao === null ? null : Math.max(0, Math.min(1, fracao)), metros: m, percentual: pct, maximo,
    referencia: typeof lamina === "number" && lamina > 0 ? "lâmina" : "máx. operacional" };
}
